module.exports = __webpack_public_path__ + "static/media/4.e04e3d58.png";